import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Game from './Game'; // Rename your current App component to Game
import SpotifyCallback from './SpotifyCallback';

function App() {
  return (
    <Router basename="/featurechain">
      <Routes>
        <Route path="/" element={<Game />} />
        <Route path="/callback" element={<SpotifyCallback />} />
      </Routes>
    </Router>
  );
}

export default App;
